export default __webpack_public_path__ + "static/media/bg.db4926ce.gif";